import axios from "axios";
import { CognitoTokenResponse, UserResponse } from "modules/types/user";
import { RequestService } from "services/request.service";

export class RoutesApi extends RequestService {}
